"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAllFuturesIndexMap = exports.useFuturesIndexesMap = exports.useFuturesIndexes = exports.useFuturesIndex = void 0;
const react_1 = require("react");
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const Interfaces_1 = require("../../Interfaces");
const QuotationSocketMgr_1 = require("../../QuotationSocketMgr");
const useFuturesIndex = (params) => {
    const { base = "", quote = "", isActive, exchange = Interfaces_1.EXCHANGE_PIONEXV2, frequency = 1000 } = params;
    const [index, setIndex] = (0, react_1.useState)();
    (0, react_1.useEffect)(() => {
        if (!isActive || !base || !quote || !exchange) {
            return;
        }
        const sub = (0, QuotationSocketMgr_1.getGlobalQuotationSocketMgr)()
            .getFIndexWebSocket()
            .getFIndexObservableByPair(exchange, base, quote)
            .pipe((0, operators_1.throttleTime)(frequency ? frequency : 0, rxjs_1.asapScheduler))
            .subscribe({
            next: (res) => {
                setIndex(res);
            },
            error: (err) => { },
        });
        return () => sub.unsubscribe();
    }, [base, exchange, frequency, isActive, quote]);
    return index;
};
exports.useFuturesIndex = useFuturesIndex;
const useFuturesIndexes = (symbolList, isActive, frequency = 1000) => {
    const [indexes, setIndexes] = (0, react_1.useState)([]);
    const dep = (0, react_1.useMemo)(() => {
        const str = symbolList.map((e) => `${e.market}/${e.base}/${e.quote}`).join("-");
        return str;
    }, [symbolList]);
    (0, react_1.useEffect)(() => {
        if (!isActive || !symbolList.length) {
            return;
        }
        const sub = (0, QuotationSocketMgr_1.getGlobalQuotationSocketMgr)()
            .getFIndexWebSocket()
            .getFIndexObservableBatch(symbolList)
            .pipe((0, operators_1.throttleTime)(frequency ? frequency : 0, rxjs_1.asapScheduler))
            .subscribe({
            next: (res) => {
                setIndexes(res);
            },
            error: (err) => { },
        });
        return () => sub.unsubscribe();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [frequency, isActive, dep]);
    return indexes;
};
exports.useFuturesIndexes = useFuturesIndexes;
const useFuturesIndexesMap = (symbolList, isActive, frequency = 1000) => {
    const list = (0, exports.useFuturesIndexes)(symbolList, isActive, frequency);
    return (0, react_1.useMemo)(() => {
        const m = new Map();
        list.forEach((e) => {
            m.set(e.symbol, e);
        });
        return {
            list: list,
            map: m,
        };
    }, [list]);
};
exports.useFuturesIndexesMap = useFuturesIndexesMap;
const useAllFuturesIndexMap = (exchange = Interfaces_1.EXCHANGE_PIONEXV2, isActive, frequency = 1000) => {
    const [indexes, setIndexes] = (0, react_1.useState)(new Map());
    (0, react_1.useEffect)(() => {
        if (!isActive || !exchange) {
            return;
        }
        const sub = (0, QuotationSocketMgr_1.getGlobalQuotationSocketMgr)()
            .getFIndexWebSocket()
            .getFIndexObservableByEx(exchange)
            .pipe((0, operators_1.throttleTime)(frequency ? frequency : 0))
            .subscribe({
            next: (res) => {
                setIndexes(res);
            },
            error: (err) => { },
        });
        return () => sub.unsubscribe();
    }, [exchange, frequency, isActive]);
    return indexes;
};
exports.useAllFuturesIndexMap = useAllFuturesIndexMap;
